import type {Swag} from "./types.ts";

export const DEFAULT_ITEM: Swag = {
    id: "default",
    name: "Default",
    altText: "khanmigo",
    description: "Khanmigo",
    price: 0,
    __typename: "AiGuideSwag",
};
